import { FC } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Avatar,
  Button,
  Stack,
  Divider,
  useTheme
} from '@mui/material';
import { useAuth } from 'src/hooks/use-auth';
import type { AuthContextType as JwtAuthContextType } from 'src/contexts/auth/jwt-context';
import { useRouter } from 'src/hooks/use-router';
import { paths } from 'src/paths';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import toast from 'react-hot-toast';
import { useSelector } from 'src/store';
import { selectUser } from 'src/slices/user';

export const Profile: FC = () => {
  const auth = useAuth<JwtAuthContextType>();
  const router = useRouter();
  const theme = useTheme();
  
  // Subscribe to user data from Redux
  const user = useSelector(selectUser);
  

  const handleLogout = async () => {
    try {
      await auth.signOut();
      router.push(paths.index);
    } catch (err) {
      console.error(err);
      toast.error('Something went wrong!');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Card>
        <CardContent>
          <Stack spacing={3}>
            {/* Profile Header */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  bgcolor: theme.palette.primary.main
                }}
              >
                <PersonIcon sx={{ fontSize: 40 }} />
              </Avatar>
              <Box>
                <Typography variant="h5">
                  {user?.name || auth.user?.name || 'User'}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {user?.email || auth.user?.email || 'No email available'}
                </Typography>
              </Box>
            </Box>

            <Divider />

            {/* Profile Information */}
            <Stack spacing={2}>
              <Typography variant="h6">Profile Information</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  Name
                </Typography>
                <Typography variant="body1">
                  {user?.name || auth.user?.name || 'Not provided'}
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" color="text.secondary">
                  Email
                </Typography>
                <Typography variant="body1">
                  {user?.email || auth.user?.email || 'Not provided'}
                </Typography>
              </Box>
              {user?.id && (
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                  <Typography variant="body2" color="text.secondary">
                    User ID
                  </Typography>
                  <Typography variant="body1">
                    {user.id}
                  </Typography>
                </Box>
              )}
            </Stack>

            <Divider />

            {/* Logout Section */}
            <Box>
              <Button
                variant="outlined"
                color="error"
                startIcon={<LogoutIcon />}
                onClick={handleLogout}
                 sx={{
                  width:"fit-content"

                 }}
              >
                Logout
              </Button>
            </Box>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}; 